import { render } from "./CreateGiveawayView.vue?vue&type=template&id=1b6d58b0&ts=true"
import script from "./CreateGiveawayView.vue?vue&type=script&lang=ts"
export * from "./CreateGiveawayView.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Documents\\Development\\juwie-giveaway\\juwie-giveaway-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__